import Script from 'next/script';

import type { FrontifyImageContent } from '@/contentful';
import { setImgWidth } from '@/utils/frontify';

const logo: FrontifyImageContent = {
  id: 23854,
  title: 'Off White',
  ext: 'png',
  height: 1080,
  width: 1080,
  created: '2024-01-17T22:53:37.000+00:00',
  generic_url:
    'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9maWxlXC9yaUYzY1l0RnViMmdHWXhCMThqeS5wbmcifQ:sunrun:2xbMQhAAvTYe1dq4uoT9tdjSQMa4CFxwyhbAdfvmj6k?width={width}',
  preview_url:
    'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9maWxlXC9yaUYzY1l0RnViMmdHWXhCMThqeS5wbmcifQ:sunrun:2xbMQhAAvTYe1dq4uoT9tdjSQMa4CFxwyhbAdfvmj6k?width=800',
  src: 'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9maWxlXC9yaUYzY1l0RnViMmdHWXhCMThqeS5wbmcifQ:sunrun:2xbMQhAAvTYe1dq4uoT9tdjSQMa4CFxwyhbAdfvmj6k?width=800',
};

export default function StaticSchema() {
  return (
    <Script type='application/ld+json' strategy='beforeInteractive'>
      {`{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Sunrun",
        "url": "https://www.sunrun.com/",
        "logo": "${setImgWidth(logo.preview_url, 1080, 'png')}",
        "sameAs": [
            "https://www.facebook.com/sunrun",
            "https://twitter.com/Sunrun/",
            "https://www.instagram.com/sunrunsolar/",
            "https://www.linkedin.com/company/sunrun/"
            ]
        }`}
    </Script>
  );
}
